import React, {Component} from "react";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Exercise from '../Exercise/Exercise';
import PaginationWidget from "../UI/PaginationWidget/PaginationWidget";
import classes from './ExercisesList.module.css';
import axios from "axios";
import apiUrl from "../../shared/config";
import AnchorLink from "react-anchor-link-smooth-scroll";

class ExercisesList extends Component {

    state = {
        count: 0,
        authenticated: false,
        patternExercises: []
    };

    componentDidMount() {

        //console.log("In Exercise List mount. Exercise Id: " + this.props.exerciseId);
        const url = apiUrl +'Exercises/getExercises';
        //add a +1 to autnenticated when adding the 'create new exercise' card
        const quantity = (this.props.isAuthenticated ? this.props.patternExercises.quantity : this.props.patternExercises.quantity );
        const params = {
            params: {
                quantity: quantity,
                offset: this.props.patternExercises.offset,
                //game_name_filter: this.props.gameNameFilter,
                //game_description_filter: this.props.gameDescriptionFilter,
                //game_type_ids_array: this.props.gameTypesFilter,
                //game_publisher_ids_array: this.props.gamePublishersFilter,
                //game_developer_ids_array: this.props.gameDevelopersFilter,
                //game_style_id: this.props.gameStyleFilter,
                //start_date: this.props.releaseStartFilter,
                //end_date: this.props.releaseEndFilter,
                //keyword_ids_array: this.props.keywordsFilter,
                //author: this.props.authorFilter,
                //order_by: this.props.order_by,
            }
        };
        axios.get(url, params)
            .then(response => {
                this.setState({patternExercises: response.data.exercises_array});
                this.setState({count: response.data.exercise_count});
                this.props.updateCount(response.data.exercise_count);
                this.setState({authenticated: this.props.isAuthenticated});
            }).then(
            this.props.listReloaded()
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log("In Exercise List update. Exercise Id: " + this.props.exerciseId);
        if(
            this.props.reloadList === true ||
            prevProps.patternExercises.offset !== this.props.patternExercises.offset ||
            //prevProps.order_by !== this.props.order_by ||
            this.props.isAuthenticated !== this.state.authenticated
        ) {
            const url = apiUrl +'Exercises/getExercises';
            this.setState({authenticated: this.props.isAuthenticated});
            //add a +1 to autnenticated when adding the 'create new exercise' card
            const quantity = (this.props.isAuthenticated ? this.props.patternExercises.quantity : this.props.patternExercises.quantity);
            const params = {
                params: {
                    quantity: quantity,
                    offset: this.props.patternExercises.offset,
                    //game_name_filter: this.props.gameNameFilter,
                    //game_description_filter: this.props.gameDescriptionFilter,
                    //game_type_ids_array: this.props.gameTypesFilter,
                    //game_publisher_ids_array: this.props.gamePublishersFilter,
                    //game_developer_ids_array: this.props.gameDevelopersFilter,
                    //game_style_id: this.props.gameStyleFilter,
                    //start_date: this.props.releaseStartFilter,
                    //end_date: this.props.releaseEndFilter,
                    //keyword_ids_array: this.props.keywordsFilter,
                    //author: this.props.authorFilter,
                    //order_by: this.props.order_by,
                }
            };
            axios.get(url, params)
                .then(response => {
                    this.setState({patternExercises: response.data.exercises_array});
                    this.setState({count: response.data.exercise_count});
                    this.props.updateCount(response.data.exercise_count);
                })
                .then(
                    this.props.listReloaded()
                );
        }
    }

    render() {
        // let newExerciseSlug = (
        //     <Col className={classes.ExerciseListCol} key="0">
        //         <Game
        //             selected="NewExerciseList"
        //             key="0"
        //             name="Add New Exercise"
        //             description="Open the New Exercise panel to add a exercise."
        //             clicked={() => {
        //                 this.props.newExercise(null);
        //                 this.props.closeExerciseDetails();
        //                 this.props.exerciseSelected(null);
        //             }}
        //         />
        //     </Col>
        // );
        // newExerciseSlug = (this.props.isAuthenticated ? newExerciseSlug : '');
        //add a +1 to autnenticated when adding the 'create new exercise' card
        const quantity = (this.props.isAuthenticated ? this.props.patternExercises.quantity : this.props.patternExercises.quantity);

        const patternExercises = this.state.patternExercises.map(exercise => {
            let isSelected = '';
            if(this.props.selectedExerciseId === exercise.exercise_id) {
                isSelected = ' selected';
            }

            return (
                <Col className={classes.ExerciseListCol} key={exercise.exercise_id}>
                    <AnchorLink className="no-link-style" offset='80' href='#exercise-details'>
                        <Exercise
                            selected={isSelected}
                            key={exercise.exercise_id}
                            name={exercise.exercise_id + '. ' + exercise.exercise_name}
                            description={exercise.exercise_description}
                            clicked={
                                () => {
                                    this.props.exerciseSelected(exercise.exercise_id)
                                    this.props.executionSelected(exercise.execution_id)
                                }
                            }
                        />
                    </AnchorLink>
                </Col>
            )
        });

        return (
            <div className={"d-flex "+classes.ExerciseListWrapper}>
                <div className={classes.ExerciseList}>
                    <Container fluid className={classes.ExerciseListContainer} >
                        <Row xs={1} md={2} lg={2} xl={3} >
                            {patternExercises}
                        </Row>
                        <Row className={classes.ExerciseListPagination}>
                            <PaginationWidget
                                className="col-sm-6 align-self-center"
                                updatePage={this.props.updatePage}
                                count={this.state.count}
                                quantity={quantity}
                                offset={this.props.patternExercises.offset}
                            />
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}



export default ExercisesList;